import React from 'react'

import { Button } from 'semantic-ui-react'


const onClickFn = (value) => (e) => {
    e.preventDefault();

    const el = document.createElement('textarea');
    el.value = value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}

const ButtonCopy = ({ label, value, ...otherProps }) =>
    <Button {...otherProps} onClick={onClickFn(value)}>
        {label}
    </Button>;


export default ButtonCopy


// WEBPACK FOOTER //
// ./src/components/forms/ButtonCopyToClipboard.js